import React, { FC, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { clsxm } from "@/utils/clsxm";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  closeOnBackdropClick?: boolean;
  backgroundStyle?: 'blur' | 'purple' | 'none';
  isScrollable?: boolean;
}

const Modal: FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  closeOnBackdropClick = false,
  backgroundStyle = 'blur',
  isScrollable = false,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(isOpen);
    if (isOpen) {
      const originalStyle = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  let modalRoot = document.getElementById("modal-root");
  if (!modalRoot) {
    modalRoot = document.createElement("div");
    modalRoot.setAttribute("id", "modal-root");
    document.body.appendChild(modalRoot);
  }

  return createPortal(
    <div className="fixed inset-0 z-50 flex flex-col">
      <div
        className={clsxm("absolute inset-0", {
          'bg-white bg-opacity-50 backdrop-blur-sm': backgroundStyle === 'blur',
        })}
        onClick={closeOnBackdropClick ? onClose : undefined}
      />
      <div
        className={clsxm(
          "relative mt-auto w-full bg-white py-12 px-4 sm:px-10 shadow-2xl shadow-black transition-transform duration-300 transform",
          visible ? "translate-y-0" : "translate-y-full",
          backgroundStyle === 'purple' && 'bg-main-button-v2/80',
          isScrollable && 'overflow-auto',
        )}
      >
        {children}
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
